import metaClient from './meta-client';

export interface ClickSummary {
    period: { start: string; end: string };
    totals: {
        clicks: number;
        unique_leads: number;
        clicks_broadcast: number;
        clicks_funnel: number;
        sent_broadcast: number;
        sent_with_buttons: number;
        ctr_broadcast: number; // %
    };
}

export interface PreviewButton {
    text: string;
    type: 'url' | 'postback' | string;
}

export interface PreviewBlock {
    type: string; // text | image | video | audio | photo_template | etc
    message: string;
    title: string;
    subtitle: string;
    media_url: string | null;
    media_type: string | null;
    buttons: PreviewButton[];
}

export interface BroadcastPageRow {
    broadcast_id: number;
    page_id: string | null;
    page_name: string;
    total_sent: number;
    total_failed: number;
    total_leads: number;
    clicks: number;
    unique_clicks: number;
    ctr: number; // %
    has_buttons: boolean;
    created_at: string;
}

export interface BroadcastReportRow {
    broadcast_id: number;          // id mestre do grupo (menor id)
    group_broadcast_id: number;
    title: string;
    created_at: string;
    total_sent: number;
    total_failed: number;
    total_leads: number;
    clicks: number;
    unique_clicks: number;
    ctr: number; // % ponderado do grupo
    has_buttons: boolean;
    buttons_count: number;
    blocks: PreviewBlock[];
    pages_count: number;
    pages: BroadcastPageRow[];
}

export interface FunnelReportNode {
    node_id: number | null;
    node_name: string;
    node_type: string | null;
    clicks: number;
    unique_clicks: number;
}

export interface FunnelReportRow {
    funnel_id: number;
    funnel_name: string;
    total_clicks: number;
    unique_clicks: number;
    nodes: FunnelReportNode[];
}

export interface TimelineBucket {
    bucket: string; // ISO datetime
    total: number;
    broadcast: number;
    funnel: number;
    unique_leads: number;
}

const params = (start?: string, end?: string, extra: Record<string, any> = {}) => {
    const p: Record<string, any> = { ...extra };
    if (start) p.start = start;
    if (end) p.end = end;
    return p;
};

export const getClickSummary = async (start?: string, end?: string): Promise<ClickSummary> => {
    const r = await metaClient.get<ClickSummary>('/meta/reports/clicks/summary', { params: params(start, end) });
    return r.data;
};

export const getBroadcastsReport = async (
    start?: string, end?: string, limit = 50,
    withButtons?: boolean | null,
): Promise<BroadcastReportRow[]> => {
    const extra: Record<string, any> = { limit };
    if (withButtons === true) extra.with_buttons = true;
    if (withButtons === false) extra.with_buttons = false;
    const r = await metaClient.get<BroadcastReportRow[]>('/meta/reports/clicks/broadcasts', {
        params: params(start, end, extra),
    });
    return r.data;
};

export const getFunnelsReport = async (start?: string, end?: string): Promise<FunnelReportRow[]> => {
    const r = await metaClient.get<FunnelReportRow[]>('/meta/reports/clicks/funnels', { params: params(start, end) });
    return r.data;
};

export const getClickTimeline = async (
    start?: string, end?: string, bucket: 'hour' | 'day' = 'hour'
): Promise<TimelineBucket[]> => {
    const r = await metaClient.get<TimelineBucket[]>('/meta/reports/clicks/timeline', {
        params: params(start, end, { bucket }),
    });
    return r.data;
};
